const useDeepLink = (match) => {
  const { params } = match;
  const { siteId, folderId, resourceId } = params;

  return !!siteId ? { siteId, folderId, resourceId } : undefined;
};

export default useDeepLink;
